import { all, call, put, takeLatest } from 'redux-saga/effects';
import { draftMailActions } from './draftMailSlice';
import { fetchDraftMailTypes } from 'services/mailService';
import { notificationHandler } from 'utils/utils';

function* getDraftMailTypes() {
    try {
        const draftMailTypes = yield call(fetchDraftMailTypes);
        yield put(draftMailActions.setDraftMailTypesData(draftMailTypes || {}));
    } catch (err) {
        yield call(notificationHandler, {
            err,
            title: 'Error getting draft mail types!',
        });
    }
}

function* onGetDraftMailTypes() {
    yield takeLatest(draftMailActions.getDraftMailTypesData.type, getDraftMailTypes);
}

export function* draftMailSaga() {
    yield all([call(getDraftMailTypes), call(onGetDraftMailTypes)]);
}
